import { useRef, useState } from "react";
import NexratesCounterpartiesList, { NexratesCounterpartiesListHandle } from "./NexratesCounterpartiesList";
import NexratesCounterpartiesModal, { ModalMode } from "./NexratesCounterpartiesModal";

const NexratesCounterparties: React.FC = () => {

    const [modalMode, setModalMode] = useState<ModalMode>(ModalMode.NONE);
    const [modalCode, setModalCode] = useState<string | undefined>(undefined);

    const handleClickView = (code: string) => {
        setModalMode(ModalMode.VIEW);
        setModalCode(code);
    }

    const handleClickEdit = (code: string) => {
        setModalMode(ModalMode.EDIT);
        setModalCode(code);
    }    

    const handleClickCreate = () => {
        setModalMode(ModalMode.CREATE);
        setModalCode(undefined);
    }    

    const handleCloseModal = (refresh: boolean) => {
        setModalMode(ModalMode.NONE);
        refresh && listRef.current?.reloadData();
    }

    const text : string = "NexRates Counterparties Administration Application";
    const listRef = useRef<NexratesCounterpartiesListHandle>(null);

    return (
        <div className="container mt-4">
            <h1 className="text-center mb-4 d-flex align-items-center">
                <img src="softsolutionslogo.jpg" alt="SoftSolutiongs Logo" className="me-4" style={{height: '1em'}}/>{text}
            </h1>
            <NexratesCounterpartiesList ref={listRef} onClickView={handleClickView} onClickEdit={handleClickEdit} onClickCreate={handleClickCreate} />
            {modalMode !== ModalMode.NONE && <NexratesCounterpartiesModal partyCode={modalCode} onCloseModal={handleCloseModal} modalMode={modalMode} />}
        </div>
    );
};

export default NexratesCounterparties;